// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("./image.res.js");

function makeOptionItems(options, selectedOptions) {
  return List.map((function (x) {
                return {
                        name: x,
                        selected: List.exists((function (y) {
                                return y === x;
                              }), selectedOptions)
                      };
              }), options);
}

function MultipleSelectBox(props) {
  var __menuZIndexClass = props.menuZIndexClass;
  var __closeOnScroll = props.closeOnScroll;
  var __listBoxCss = props.listBoxCss;
  var __optionsHoverColor = props.optionsHoverColor;
  var __className = props.className;
  var __selectedOptions = props.selectedOptions;
  var handleChange = props.handleChange;
  var placeholderClassName = props.placeholderClassName;
  var placeholder = props.placeholder;
  var selectedOptions = __selectedOptions !== undefined ? __selectedOptions : /* [] */0;
  var className = __className !== undefined ? __className : "";
  var optionsHoverColor = __optionsHoverColor !== undefined ? __optionsHoverColor : "";
  var listBoxCss = __listBoxCss !== undefined ? __listBoxCss : "";
  var closeOnScroll = __closeOnScroll !== undefined ? __closeOnScroll : false;
  var menuZIndexClass = __menuZIndexClass !== undefined ? __menuZIndexClass : "z-50";
  var optionItems = makeOptionItems(props.options, selectedOptions);
  var match = React.useState(function (param) {
        return {
                open_: false
              };
      });
  var setState = match[1];
  var state = match[0];
  var domElement = React.useRef(null);
  var handleOutsideClick = function ($$event) {
    var targetElement = $$event.target;
    var selectBoxElement = Belt_Option.getExn(Caml_option.nullable_to_opt(domElement.current));
    if (!selectBoxElement.contains(targetElement)) {
      return Curry._1(setState, (function (param) {
                    return {
                            open_: false
                          };
                  }));
    }
    
  };
  var handlePageScroll = function (_event) {
    if (closeOnScroll) {
      return Curry._1(setState, (function (param) {
                    return {
                            open_: false
                          };
                  }));
    }
    
  };
  React.useEffect((function (param) {
          document.addEventListener("mousedown", handleOutsideClick);
          if (closeOnScroll) {
            window.addEventListener("scroll", handlePageScroll);
          }
          return (function (param) {
                    document.removeEventListener("mousedown", handleOutsideClick);
                    if (closeOnScroll) {
                      window.removeEventListener("scroll", handlePageScroll);
                      return ;
                    }
                    
                  });
        }), []);
  var handleClick = function ($$event) {
    $$event.preventDefault();
    $$event.stopPropagation();
    Curry._1(setState, (function (state) {
            return {
                    open_: !state.open_
                  };
          }));
  };
  var listBoxVisibility = state.open_ ? "block" : "hidden";
  var tmp;
  var exit = 0;
  if (placeholder !== undefined) {
    if (selectedOptions) {
      exit = 1;
    } else {
      var className$1 = placeholderClassName !== undefined ? placeholderClassName : "";
      tmp = JsxRuntime.jsx("div", {
            children: placeholder,
            className: className$1
          });
    }
  } else if (selectedOptions) {
    exit = 1;
  } else {
    tmp = "";
  }
  if (exit === 1) {
    tmp = [
      JsxRuntime.jsx("p", {
            children: selectedOptions.hd,
            className: "bg-ghostwhite text-center px-3 rounded-2xl border border-gray-400 mr-2 mb-2"
          }),
      $$Array.of_list(List.map((function (x) {
                  return JsxRuntime.jsx("p", {
                              children: x,
                              className: "bg-ghostwhite text-center px-3 rounded-2xl border border-gray-400 mr-2 mb-2"
                            });
                }), selectedOptions.tl))
    ];
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: tmp,
                                    className: "flex flex-wrap"
                                  }),
                              className: "text-sm min-w-0 flex-1"
                            }),
                        state.open_ ? JsxRuntime.jsx("img", {
                                className: "shrink-0 h-4 w-4",
                                src: Image$ReactHooksTemplate.chevronUp
                              }) : JsxRuntime.jsx("img", {
                                className: "shrink-0 h-4 w-4",
                                src: Image$ReactHooksTemplate.chevronDown
                              })
                      ],
                      className: "cursor-pointer flex items-center justify-between gap-2 " + className,
                      onClick: handleClick
                    }),
                JsxRuntime.jsx("div", {
                      children: $$Array.of_list(Belt_List.mapWithIndex(optionItems, (function (i, x) {
                                  return JsxRuntime.jsx("div", {
                                              children: x.name,
                                              className: x.selected ? "text-left text-white bg-palatinateblue px-4 py-2" : "text-left px-4 py-2 bg-white " + optionsHoverColor,
                                              value: x.name,
                                              onClick: (function (param) {
                                                  Curry._1(handleChange, x.name);
                                                })
                                            }, String(i));
                                }))),
                      className: "flex flex-col border " + menuZIndexClass + " bg-white w-full overflow-y-auto cursor-pointer rounded-lg " + listBoxCss + listBoxVisibility,
                      style: {
                        left: "0px",
                        maxHeight: "40vh",
                        position: "absolute",
                        top: "100%"
                      }
                    })
              ],
              ref: Caml_option.some(domElement),
              className: "relative"
            });
}

var make = MultipleSelectBox;

exports.makeOptionItems = makeOptionItems;
exports.make = make;
/* react Not a pure module */
